<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="5.45898"
      y="4.39844"
      width="20"
      height="1.5"
      rx="0.2"
      transform="rotate(45 5.45898 4.39844)"
      fill="#BFBFBF"
    />
    <rect
      x="19.6016"
      y="5.45898"
      width="20"
      height="1.5"
      rx="0.2"
      transform="rotate(135 19.6016 5.45898)"
      fill="#BFBFBF"
    />
  </svg>
</template>
<script lang="ts">
export default {
  name: 'IconClose'
}
</script>
